module.exports = __webpack_public_path__ + "img/SuperMarioLandTitleScreen.cbe1d880.png";